import { Box } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { BoardSearchListState, DialogMessageState } from "../../recoil/states";
import { TopSearchActions } from "../../reducers/TopSearchReducer";
import { AppDispatch, RootState } from "../../Store";
import CommonUtil from "../../utils/CommonUtil";

const TopSearch = () => {

    const inputValSearch = useSelector((state: RootState) => state.TopSearchReducer.inputValSearch); // 검색어 입력박스 이벤트 처리를 위한 state
    const setBoardSearchListState = useSetRecoilState(BoardSearchListState); // 검색 화면 페이징 처리를 위해 사용되는 state
    const setDialogMessageState = useSetRecoilState(DialogMessageState); // 다일얼로그 메세지 요청 정보를 갖는 state
    const dispatch = useDispatch<AppDispatch>();

    const refInputValSearch = useRef<HTMLInputElement>(null); // 검색 키워드 입력박스 참조 객체
    const refBtnSearch = useRef<HTMLAnchorElement>(null); // 검색 링크 버튼 참조 객체

    // 쿼리스트링으로 전달된 검색어가 존재할 경우, 최초 화면 호출 시 검색어 입력박스에 세팅
    useEffect(() => {
        const search_keyword = CommonUtil.getQuerystring("search_keyword", "");
        dispatch(TopSearchActions.setInputValSearch(search_keyword));
        return () => {
        }
    }, [dispatch]);

    /**
    * 검색어 입력박스 change 이벤트
    * 
    * @param e 이벤트 객체
    * @returns 
    */
    const handlerInputValSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
        dispatch(TopSearchActions.setInputValSearch(e.target.value));
    }

    /**
    * 검색 버튼 클릭 이벤트
    * 
    * @param e 이벤트 객체
    * @returns 
    */
    const handlerSearchBtn = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();

        const iptEl: HTMLInputElement | null = refInputValSearch.current;
        if (iptEl === null) return;

        /**
        * TextBox 폼 체크
        * @param {HTMLInputElement | null} refObj ref 객체
        * @param {string} name ref 객체명
        * @returns {boolean}
        */
        const TextBoxConfirm = (refObj: HTMLInputElement | null, name: string): boolean => {

            if (refObj?.value.trim() === "") {

                const message = name + " 입력하세요.";
                const callbackFuncOk = () => {
                    refObj.value = "";
                    refObj.focus();
                };
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message, callbackFuncOk }));

                return false;
            }
            return true;
        }

        if (!TextBoxConfirm(iptEl, "'검색어'를")) return;
        if (iptEl.value.trim().length < 2) {
            const message = "최소 2자 이상 검색 가능합니다.";
            const callbackFuncOk = () => iptEl.select();
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message, callbackFuncOk }));
            return;
        }

        const url: string = "/board_search_list?search_keyword=" + encodeURIComponent(iptEl.value);
        (window as any).urlChange(url);

        setBoardSearchListState(rawState => ({ ...rawState, currPage: 1 })); // 검색 화면 렌더링 요청
    }

    /**
    * 입력창 엔터 키 체크 이벤트
    * 
    * @param e 이벤트 객체
    * @returns 
    */
    const handlerInputEnterProc = (e: React.KeyboardEvent<HTMLInputElement>) => {

        const btnEl: HTMLAnchorElement | null = refBtnSearch.current;
        if (e.key === "Enter") {
            $(e.target).trigger("blur");
            btnEl?.click();
        }
    }

    return (
        <>
            <ul className="hd_qnb">
                <li id="li_search_ui">
                    <a href="#none" className="sch_btn" ref={refBtnSearch} onClick={handlerSearchBtn}><i className="fa fa-search fa-2x"></i> </a>
                </li>
            </ul>
            <Box className="hd_sch" sx={{ width: { md: "70%", sm: "65%", xs: "45%" } }}>
                <div className="sch_ipt">
                    <input type="text" value={inputValSearch} enterKeyHint="done" onChange={handlerInputValSearch} onKeyDown={handlerInputEnterProc} ref={refInputValSearch} className="sch_stx" maxLength={100} placeholder="검색어를 입력하세요" autoComplete="off" />
                    <input type="text" style={{ display: "none" }} />
                </div>
            </Box >
        </>
    )
}

export default TopSearch;
